<template>
    <div class="label-type-toggle" :class="{loading: loading}">
        <button type="button" class="btn btn-sm" v-for="labelType in labelTypesWithLabels"
                @click="toggleLabel(labelType)"
                :style="getStyle(labelType)">
            <i class="fa fa-check-circle" aria-hidden="true" v-if="labelType.label"></i> {{labelType.title}}
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            labelableType: {
                type: String,
                required: true
            },

            labelableId: {
                type: String,
                required: true
            },

            afterSave: {
                default: () => {
                    return function(){
                    };
                }
            }
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: false,

                labelTypes: [],
                labels: [],
            };
        },

        computed: {
            labelTypesWithLabels(){
                return _.map( this.labelTypes, ( labelType ) => {
                    labelType.label = _.find( this.labels, { label_type_id: labelType.id } );

                    return labelType;
                } );
            },
        },

        watch: {
            labelableId(){
                this.$nextTick( () => {
                    this.init();
                } );
            },
        },

        methods: {
            /** Address **/
            loadLabelTypes(){
                var url = '/api/labelTypes?labelable_type=' + this.labelableType;

                return axios.get( url )
                    .then( ( response ) => {
                        var labelTypes = response.data.LabelTypes;

                        this.$set( this, 'labelTypes', labelTypes );
                    } );
            },

            loadLabels(){
                var url = '/api/labels?labelable_type=' + this.labelableType +
                    '&labelable_id=' + this.labelableId;

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'labels', response.data.Labels );
                    } );
            },

            toggleLabel( labelType ){
                if( labelType.label ){
                    return this.archiveLabel( labelType.label );
                }
                else {
                    return this.createLabel( labelType );
                }
            },

            createLabel( labelType ){
                this.loading = true;

                return axios.post( '/api/labels', {
                    Label: {
                        labelable_id: this.labelableId,
                        labelable_type: this.labelableType,
                        label_type_id: labelType.id
                    }
                } )
                    .then( () => {
                        return this.loadLabels();
                    } )
                    .then( () => {
                        this.afterSave();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            archiveLabel( label ){
                this.loading = true;

                return axios.delete( '/api/labels/' + label.id )
                    .then( () => {
                        return this.loadLabels();
                    } )
                    .then( () => {
                        this.afterSave();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            getStyle( labelType ){
                // If Toggled
                if( labelType.label ){
                    return {
                        'background-color': labelType.color
                    };
                }

                return {
                    color: labelType.color
                };
            },

            /** Hooks **/
            init(){
                return Promise.all( [
                    this.loadLabelTypes(),
                    this.loadLabels()
                ] )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            /** Instance Functions **/
            openModal(){
                this.$modal.show( this.modalId );
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            }
        }
    }
</script>
